import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const MiscellaneousLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#38670A"
        d="M1242.4 395.3c1.4-4.2-4.3-15-4.3-15s2.1-3.5 5.3-3.5c3.2 0 3.6 2.4 3.6 2.4s2.7 11.2.2 17c-1.7.2-4.8-.9-4.8-.9zM1325.2 401.2c1.3-4.2-4.5-15-4.5-15s2-3.6 5.3-3.6c3.2 0 3.6 2.4 3.6 2.4s2.8 11.1.5 17c-1.9.3-4.9-.8-4.9-.8zM1267.8 406.5c1.3-4-4.1-14.4-4.1-14.4s2-3.4 5.1-3.4c3.1 0 3.5 2.3 3.5 2.3s2.6 10.7.2 16.3c-1.8.3-4.7-.8-4.7-.8z"
      />
      <linearGradient
        id="SVGID_19_"
        x1="1209.303"
        x2="1286.501"
        y1="427.045"
        y2="427.045"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_19_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M1269.3 459.8l-35.7 3.6c-9.3 1-17.6-5.8-18.6-15.2l-3.6-35.3c-1-9.3 5.8-17.6 15.2-18.6l35.7-3.6c9.3-1 17.6 5.8 18.6 15.2l3.6 35.3c.9 9.3-5.9 17.6-15.2 18.6z"
      />
      <path
        fill="#68C902"
        d="M1280.1 471.9c-2.9-4.8-8.4-7.9-14.3-8.3 2.1 1 7.6 5.9 7.6 5.9s-5.7-3.2-7.8-2.7c6.5 2.5 8.8 6.6 8.8 6.6s-3-2.1-5.5-1c6.4 1.7 11.2 5 11.2 5l4.1.3-4.1-5.8z"
      />
      <image
        width="56"
        height="56"
        x="1219.5"
        y="385.6"
        transform="rotate(-5.82 1386.5 413.5)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_20_"
        x1="1291.531"
        x2="1368.728"
        y1="432.878"
        y2="432.878"
        gradientTransform="rotate(3.551 1340.948 459.91) scale(1.00002)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_20_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M1351.1 466.2l-35.8 1.4c-9.4.4-17.3-6.9-17.6-16.3l-1.4-35.5c-.4-9.4 6.9-17.3 16.3-17.6l35.8-1.4c9.4-.4 17.3 6.9 17.6 16.3l1.4 35.5c.4 9.4-6.9 17.3-16.3 17.6z"
      />
      <image
        width="56"
        height="56"
        x="1304"
        y="404.5"
        transform="rotate(-2.27 1332 432.5)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#0B560A"
        d="M1145.7 475.6c1.6-4.5-4.5-16.3-4.5-16.3s2.3-3.8 5.8-3.7c3.5.1 3.9 2.7 3.9 2.7s2.7 12.1 0 18.4c-2 .2-5.2-1.1-5.2-1.1z"
      />
      <linearGradient
        id="SVGID_16_"
        x1="1107.988"
        x2="1204.671"
        y1="512.572"
        y2="512.572"
        gradientTransform="rotate(-33.382 1154.137 513.293)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_16_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M1178.6 548.9l-39.2 3.5c-10.9 1-20.5-7.1-21.5-18l-3.5-38.7c-1-10.9 7.1-20.5 18-21.5l39.2-3.5c10.9-1 20.5 7.1 21.5 18l3.5 38.7c1 10.9-7.1 20.5-18 21.5z"
      />
      <path
        fill="#8F4F29"
        d="M1201.1 558.7c-2.9-5-6.7-9.7-12-12s-12.2-1.3-15.7 3.3c-7.8-6.6-21.1-5.2-27.3 2.9-7.8-6.7-18.2-10.2-28.5-9.6 2 2.7 4.7 5.1 7.5 7l13.8 9.6c4.9 3.4 6.9 10.2 12.9 10.7 5.5.4 11.9-.5 16.6 2.5 2.2 1.4 6.7-.9 8.4 1s4 3.6 6.5 3.4c2.7-.3 4.7-2.6 6.3-4.8 2.6 2.6 7 2.4 10.2.7 2.7-1.5 4.9-4.2 5.1-7.3.2-3.2-.8-6.7-3.8-7.4z"
      />
      <path
        fill="#852D31"
        d="M1159.5 562.2s2.5-6.5 9.5-4 6.8 4.2 6.8 4.2l-16.3-.2z"
      />
      <image
        width="60"
        height="60"
        x="1125.3"
        y="482"
        transform="rotate(-5.09 1155.3 512)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#38670A"
        d="M1249.2 472.3c1.9-4-2.3-15.5-2.3-15.5s2.5-3.2 5.7-2.8 3.3 2.9 3.3 2.9 1.2 11.4-2 16.9c-1.8 0-4.7-1.5-4.7-1.5z"
      />
      <linearGradient
        id="SVGID_17_"
        x1="1214.409"
        x2="1295.185"
        y1="504.259"
        y2="504.259"
        gradientTransform="rotate(7.406 1239.032 502.913)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_17_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M1273.7 543.1l-40.4-1.1c-9-.2-16-7.7-15.8-16.7l1.1-40c.2-9 7.7-16 16.7-15.8l40.4 1.1c9 .2 16 7.7 15.8 16.7l-1.1 40c-.3 9-7.7 16-16.7 15.8z"
      />
      <path
        fill="#8F4F29"
        d="M1228.9 548.8s2.8-4.2 7.8-6 9.5 1.2 9.5 1.2 5.2-6 10.5-7 9.5 2 9.5 2 2-5 5.2-1.8 1.5 8.2 1.5 8.2-29.2 5-35 5-10-1.2-10-1.2l1-.4z"
      />
      <image
        width="56"
        height="56"
        x="1226.5"
        y="478.5"
        transform="rotate(1.58 1253.5 506.5)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
      <path
        fill="#68C902"
        d="M1230.1 550s-3.2-15.6 8.2-23.3c-5.2 15-2 23-2 23s.5-10.2 4.8-14.2c-2.2 8-1 21-1 21l-2.8-4.4-1.2 4.9-3.2-11.5c0-.1-2.8 3-2.8 4.5z"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#38670A"
        d="M1352.7 482.9c3.1-3.2 2.7-15.6 2.7-15.6s3.5-2.3 6.4-.9c2.9 1.4 2.2 3.8 2.2 3.8s-2.5 11.4-7.3 15.6c-1.7-.5-4-2.9-4-2.9z"
      />
      <linearGradient
        id="SVGID_18_"
        x1="1302.628"
        x2="1391.211"
        y1="517.283"
        y2="517.283"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_18_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M1352.3 558.4l-35.9-13c-9.3-3.4-14.1-13.6-10.7-22.9l12.9-35.5c3.4-9.3 13.6-14.1 22.9-10.7l35.9 13c9.3 3.4 14.1 13.6 10.7 22.9l-12.9 35.5c-3.3 9.3-13.6 14-22.9 10.7z"
      />
      <image
        width="56"
        height="56"
        x="1319"
        y="489.5"
        transform="rotate(19.95 1347 517.5)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#38670A"
        d="M1270.9 555.3c1.8-5.9-6.3-20.7-6.3-20.7s2.8-4.9 7.3-5c4.4 0 5.1 3.3 5.1 3.3s3.9 15.4.7 23.5c-2.5.4-6.8-1.1-6.8-1.1z"
      />
      <linearGradient
        id="SVGID_15_"
        x1="1239.549"
        x2="1319.724"
        y1="583.89"
        y2="583.89"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_15_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M1301.5 617.5l-35.4 4.2c-10 1.2-19.2-6-20.3-16l-4.1-35c-1.2-10 6-19.2 16-20.3l35.4-4.2c10-1.2 19.2 6 20.3 16l4.1 35c1.3 10-5.9 19.1-16 20.3z"
      />
      <image
        width="56"
        height="56"
        x="1251.5"
        y="556"
        transform="rotate(-6.91 1279.5 584)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
      <path
        fill="#68C902"
        d="M1258 613.5c-5-8.5-14.7-13.8-25-14.5 3.7 1.7 13.3 10.3 13.3 10.3s-10-5.7-13.7-4.7c11.3 4.3 15.5 11.5 15.5 11.5s-5.3-3.7-9.7-1.7c11.2 3 19.7 8.8 19.7 8.8l7.2.5-7.3-10.2z"
      />
      <path
        fill="#8F4F29"
        d="M1315.4 608.1c-2.8-2-6.6-2.4-9.9-1.3-1.7.6-3.4 1.6-3.9 3.4.5-1.9-.8-4-2.6-5-1.8-.9-3.9-1-5.9-1.1-2.4-.1-4.9-.1-7 1-3.5 1.8-5 6-5.6 9.9-5.1-3.6-13.2-1.6-16.1 4-.6 1.1-1 2.4-1.7 3.4-.4.6-.8 1.5-.2 1.8-1.2-1.3-2.3-2.6-3.5-3.8-1.2-1.2-2.4-2.6-4-3-1.6-.5-3.7.3-4.1 2-.4 1.9 1.7 3.4 3.5 4.3 6.5 3 13.5 4.8 20.6 5.2 3.2.2 6.4.1 9.6.6 4.7.7 9.2 2.7 14 2.8s10.2-2.7 10.6-7.5c2.9.8 6.3.9 8.8-.8 4.9-3.6 1.3-13-2.6-15.9z"
      />
      <path
        fill="#68C902"
        d="M1299 616.2s-3.2-15.6 8.2-23.3c-5.2 15-2 23-2 23s.5-10.2 4.8-14.2c-2.2 8-1 21-1 21l-2.8-4.4-1.2 4.9-3.2-11.5c-.1-.1-2.8 2.9-2.8 4.5z"
      />
    </g>
  );

  return (
    <g id="group-3" transform="translate(0, -83)">
      <g id="element-3">
        <g id="component-item-3">
          <g id="miscellaneous">
            <path
              fill="#5A7E32"
              d="M1210.5 447.6c-11.4 8.8-23.7 16.5-36.6 23-6.4 3.2-13 6.1-19.8 8.7-1.7.7-3.4 1.3-5.1 1.9l-5.1 1.8-9.4 3c-5.9 1.9-10.9 3.7-15 5.9-4.3 2.1-8.3 4.8-12.1 7.9-7.5 6.2-13.6 14.2-17.7 22.9-1.9 2.3-3.4 4.8-5.1 7.4.2-1.4.2-2.9.5-4.4-.5.1-.8.3-.6.6-.4-.1-3.1-.6-4.7-1.5s-2.6-1.6-3.2-1.6c.3-.2 1.1-.3 1.9.1-1.2-.6-2.1-1.2-2.5-1.7-.5-.5-1.7-1.5-2.7-1.6 0-.5 3.4-.2 7.6 2-.9-.6-1-1-1.1-1.3 0 0 .1 0 .2.1-2.4-1.8-3.9-3.1-4.9-3.3.9-.4 3.3-.2 5 .9-2.6-1.7-4.3-3.4-5.1-4.7-.7-1.3-2.8-4-5.4-4.7.4-.8 5.2.2 11 3.5-.2-.5-.4-.9-.3-1.2 0-.8-.6-2.5-2.4-3.4.5-.2 2.8.8 5.5 2.7-.4-.8-.6-1.6-1-2.5-1.7-3.6-2.7-4.4-5.5-6.5-.7-.5-.5-1.1.1-1 .9.2 1.8.5 2.6.9.7-.4 2.4 0 3.8 1-2-1.7-3.4-3.4-4-4.8-.6-1.3-2.3-4-4.3-4.6.2-.5 2-.3 4.6 1.1 2.6 1.3 5.9 3.7 9.3 7.1-1.3-1.7-1.3-2.7-1.4-3.2.1.1.2.1.3.2-3.5-4.9-5.5-8.6-7.4-9.7 2.2-.5 6.6 1.4 9.3 4.7-3.9-5-5.9-9.5-6.1-12.8-.1-1.7-.6-4.2-1.6-6.7-1-2.6-2.5-5.1-4.9-6.6.9-.7 3.5.1 6.9 2.6 3.4 2.5 7.6 6.6 11.8 12 0-1.1.1-2 .5-2.6.8-1.5 1.4-5.3-1.2-8.6 1.3 0 4.8 3.8 8 9.6.1-1.9.6-3.5.7-5.6.2-4.2.2-6.9-.3-9.4s-1.5-4.7-3-8c-.7-1.6.5-2.6 1.5-1.9 5 3.8 8.1 10.1 10.1 18 1 3.8 1.6 7.1 2 9.8.3-.2.7-.4 1.1-.6v-.1c.1-1.3.5-2.3.6-3.6.6-5.1.1-6.6-1.5-10.9-.4-1 .3-1.6.8-1 2.7 2.7 4.5 6.7 5.5 11.8.1.4.1.7.2 1.1 1.3-.6 2.6-1.1 4-1.6-.1-.3-.2-.6-.2-.9-.5-2.4-.6-4-1-4.6.5 0 1.3.9 1.6 1.9-.4-1.7-.5-3.1-.4-4 .2-.9.1-3-.7-4 .6-.4 3.3 3.2 4.7 9.3-.1-1.4.2-2 .4-2.2 0 .1.1.1.1.2-.2-3.9-.2-6.6-.9-7.8 1.3.5 3.3 2.9 3.8 5.6-.6-4-.5-7.2.2-9.2.7-1.9 1.2-6.5-.7-9.5 1.1-.3 4.7 4.9 7.5 13.3.2-.7.5-1.2.9-1.5.8-.8 1.8-3.1.7-5.5.7.2 2.3 3.1 3.5 7.3.4-1.2 1-2.2 1.3-3.5 1.3-5.3.6-6.9-.8-11.3-.3-1.1.3-1.6.8-1 2.7 2.8 4.7 6.9 5.6 12.1.4 2.4.6 4.5.5 6.3l.9-.3c.3-.8.6-1.5.8-2.3.7-3.4.4-4.4-.6-7.1-.2-.7.2-1 .5-.7 1.8 1.7 3.1 4.3 3.7 7.5.1.3.1.6.2.9 12.2-4.5 22.8-9.1 32.9-13.9 10-4.8 19.5-9.8 29-15.7-2.8 3.6-5.7 6.8-8.7 10zm-121.1 61.9c-.4-.2-.8-.5-1.1-.7.5.7 1 1.3 1.4 1.9l.2-.5c-.2-.3-.4-.5-.5-.7zM1346.8 443.6c-5.8-2.2-11.4-4.9-16.8-7.9-2.7-1.5-5.3-3.2-7.9-4.9-2.5-1.7-4.7-3.3-6.6-4.7-3.9-2.8-6.9-4.6-8.8-5.4-1-.4-1.7-.6-2.8-.8-1-.2-2.3-.3-3.8-.3-2.9-.1-6.6.4-10.8 1.1-2.1.4-4.4.9-6.7 1.4-2.3.5-4.6 1-6.9 1.6-9.2 2.2-18.3 4.9-27.2 8-2.9.3-5.8.6-8.7 1 1.2-.8 2.4-1.6 3.5-2.4-.4-.4-.7-.4-.8-.1-.2-.3-1.5-2.8-1.9-4.5-.4-1.8-.6-3-.8-3.4.3 0 .9.7 1.1 1.5-.4-1.3-.5-2.3-.5-3 0-.7-.1-2.2-.7-3 .3-.3 2.2 2.5 3.4 7.1-.2-1 0-1.4.1-1.6 0 0 0 .1.1.2-.4-2.9-.6-4.9-1.1-5.8.8.4 2.1 2.3 2.6 4.3-.7-3-.8-5.4-.5-6.8.3-1.4.3-4.8-1-7.1.7-.2 3.1 3.8 5.2 10.3.1-.5.2-.8.4-1.1.4-.5.9-2.1.2-4.1.5.2 1.5 2.5 2.3 5.7.2-.8.5-1.5.6-2.4.6-3.8.3-5-.6-8.4-.2-.8.2-1.2.5-.7.5.7 1 1.5 1.4 2.4.6.2 1.7 1.5 2.1 3.2-.6-2.6-.8-4.7-.6-6.1.2-1.4.1-4.5-1-6.2.7-.5 4.3 5.4 6.2 14.8-.2-2.1.2-2.9.4-3.3 0 .1.1.2.1.3-.4-6-.5-10.1-1.4-12 1.7.9 4.1 4.9 4.8 9.1-.9-6.2-.8-11.1.1-13.9.9-2.8 1.6-9.6-.7-14.5 1.5-.4 6 8.2 9 21.6.3-1 .7-1.7 1.1-2.1 1-1 2.4-4.2 1.2-8.2.9.5 2.6 5.3 3.7 11.9.6-1.7 1.3-3 1.8-4.8 2.1-7.6 1.8-10.1.8-17.2-.2-1.7.7-2.3 1.3-1.3 3 5.2 4.4 12 4.5 20.2.1 3.9-.1 7.2-.4 9.9.3-.1.7-.2 1-.2v-.1c.4-1.2.9-2 1.2-3.2 1.4-4.7 1.2-6.3.8-10.8-.1-1.1.5-1.4.8-.8 1.6 3.3 2.2 7.7 2.2 12.8v1.1c1-.2 2.1-.3 3.1-.4v-.9c.1-2.4.3-4 .1-4.7.3.2.8 1.2.8 2.3 0-1.7.2-3.1.5-3.9.3-.8.7-2.8.3-4 .2-.1.7.9 1 2.7.3 1.8.5 4.4.3 7.6.2-1.3.5-1.8.7-2v.2c.7-3.8 1.4-6.4 1.2-7.7.8.9 1.5 3.8 1.1 6.5.6-4 1.6-7 2.8-8.5.6-.8 1.4-2.1 2.1-3.7.7-1.6 1.2-3.4 1-5.2.6.1 1.1 1.7 1.1 4.4.1 2.7-.4 6.4-1.3 10.8.4-.5.8-.8 1.1-.9.8-.3 2.4-1.8 3-4.4.4.6-.3 3.8-1.8 7.9.8-.8 1.5-1.3 2.3-2.2 1.8-1.8 2.9-2.9 3.9-4.2.9-1.3 1.7-2.7 2.7-4.8.5-1 1.3-.9 1.2-.2-.3 3.9-2.4 7.9-5.3 12.3-1.3 2-2.5 3.7-3.6 5l.4.3c.5-.5 1-.8 1.6-1.3 2.3-2 2.9-2.9 4.4-5.4.4-.6.8-.6.7-.1-.5 2.3-1.9 4.8-3.9 7.4-.2.3-.4.5-.6.7 3.1 2.1 6.2 4.9 9.5 7.9 1.7 1.5 3.4 3.1 5.3 4.6 1.8 1.5 3.7 3 5.5 4.4 7.4 5.7 15 10.6 23.6 14.9-2.9-.6-6.6-1.1-10.3-1.8zm-90.3-21.9c-.1-.4-.3-.8-.5-1.3v2.3l.4-.2c0-.3 0-.5.1-.8zM1493.8 507c-3.7-3.3-6.5-6.8-8.9-9.9-2.4-3.2-4.4-6.1-6.2-8.6-.9-1.2-1.7-2.4-2.5-3.5l-.6-.8-.3-.4-.1-.2c.1.1 0 0 0 .1l-.2-.1-2.6-.8-4.8-1.5-9.3-3-18-5.9c-1.6-1.2-3.1-2.4-4.6-3.6 1-.1 1.9-.1 2.9-.2 0-.5-.1-.7-.4-.5.1-.4.7-3.1 1.3-4.7.7-1.7 1.2-2.8 1.3-3.3.1.2.1 1-.2 1.8.4-1.2.9-2.2 1.2-2.7.4-.5 1-1.9 1.2-2.8.3-.1-.2 3.2-1.9 7.6.4-.9.7-1.2.9-1.3 0 0 0 .1-.1.2 1.2-2.6 2.1-4.4 2.3-5.4.2.7-.1 3-.8 4.9 1.2-2.8 2.3-4.9 3.1-5.9.8-1 2.5-3.8 3-6.4.4.1-.4 4.7-2.5 11.2.3-.4.5-.6.7-.7.5-.2 1.5-1.4 2-3.3.1.4-.5 2.8-1.6 5.9.5-.6 1-1 1.5-1.8 2.1-2.9 2.5-4.1 3.7-7.4.3-.8.6-.9.6-.4-.1.8-.3 1.8-.5 2.7.2.4.1 2.1-.5 3.7.9-2.5 1.9-4.4 2.6-5.5.7-1.1 2.1-3.8 2.4-5.8.6-.2-.5 6.5-3.9 15.5.9-1.9 1.5-2.4 1.8-2.7 0 .1-.1.2-.1.3 2.6-5.3 4.4-8.9 4.9-11 .4 1.5-.2 6.1-1.8 10 2.4-5.8 4.7-9.9 6.3-12 1.7-2.1 5-7.8 6-13 .8.3-.8 9.7-5.1 22.7.6-.7 1.1-1.2 1.5-1.4.9-.4 3-2.8 4.1-6.8.2.8-1 5.8-3.2 12 1-1.3 2-2.1 3-3.6 4.2-6 5.1-8.4 7.4-15.2.6-1.6 1.2-1.9 1.1-.7-.6 5.7-2.5 12.4-5.6 19.9-1.5 3.5-2.9 6.5-4.3 8.8l.7.2.1-.1c.7-.9 1.3-1.5 2.1-2.5 2.7-3.8 3.2-5.3 4.6-9.6.3-1 .8-1.2.7-.5-.4 3.6-1.5 7.8-3.4 12.5-.1.3-.3.7-.4 1 .8.2 1.5.4 2.3.6.1-.3.2-.6.3-.8.9-2.2 1.6-3.7 1.6-4.4.2.3.1 1.3-.2 2.4.6-1.6 1.1-2.9 1.6-3.6.4-.7 1.3-2.5 1.4-3.8.2-.1.1 1-.3 2.8-.4 1.8-1.3 4.3-2.4 7.2.5-1.2.8-1.6 1-1.8 0 .1-.1.1-.1.2 1.6-3.5 3-5.8 3.4-7.1.2.9-.7 3.8-1.9 6.2 1.9-3.6 3.7-6.2 5-7.3.7-.6 1.7-1.6 2.8-2.9 1.1-1.3 2.3-2.8 2.9-4.4.3.2 0 1.8-1.2 4.2-1.2 2.4-3.1 5.6-5.7 9.3.4-.4.8-.6 1.1-.6.6-.1 2.3-1.1 3.9-3.2 0 .6-2 3.2-5 6.4.8-.6 1.5-.9 2.5-1.5 2-1.2 3.4-2 4.7-2.9 1.3-.9 2.5-2 4.3-3.5.8-.7 1.4-.5 1 .1-2.1 3.2-5.7 6-9.9 9-1.9 1.4-3.6 2.6-4.9 3.6l.1.2c.6-.4 1-.5 1.6-.9 2.5-1.4 3.4-1.9 5.8-3.6.6-.4.9-.3.5 0-1.6 1.7-3.8 3.5-6.6 5.2-.3.2-.5.3-.8.5 2.7 4.7 4.7 9.8 7.3 15.3 1.3 2.8 2.8 5.6 4.6 8.6 1.8 3 4.1 6 6.9 8.9-2.7-1.1-5.6-2.4-8.2-3.9zm-44.7-39.1c.1-.4.2-.9.4-1.3-.4.7-.8 1.4-1.1 1.9h.3c.1-.2.3-.4.4-.6z"
            />
            <path
              fill="#FFDD83"
              d="M1522.9 508.8c-72.6-49.5-220.4-114.8-266.4-98.8-25.8 9-208.2 120.4-206.5 134.8.4 3.6 9.7 21.8 37.2 38.1 30.8 18.3 82.9 26 126.6 47.2 30.2 14.6 58.2 51.7 85.7 62.1 39.4 14.8 76.6 13.7 89.4 3.7 41.7-32.6 96.8-60.6 134-89v-98.1z"
            />
            <path
              fill="#5A7E32"
              d="M1522.9 499.5c-44.9-26.2-117.6-46.7-171.6-77.9-43-24.8-68.3-23.7-86.5-17.4-7.2 2.5-34.1 9.4-59.3 24.2-39 23-80.1 55.2-119.8 76.7-24.5 13.2-36.2 35.6-35.7 39.8.1.9 1.3 2.4 3.6 4.4 6.1-7 19.7-30.5 45.8-37.9 45.9-13 91.5-46.4 119.8-77 16.1-17.4 42.4-13.2 48.1-15.2 45.7-15.9 184.8 48.2 255.6 97.5v-17.2z"
            />
            <path
              fill="#8F4F29"
              d="M1169.2 503.2c10.9-6.7 28.2-6.6 33 4.5 11.1-4.7 27.8-3.8 34 5.7 1.5 2.3 2.7 5.1 5.1 6.5 2.5 1.4 5.6 1.2 8.5 1.1 23-.7 42.7 7.6 50.8 28.2 15.3-3.5 29.4 13.6 40.5 23.7 2.7 2.4 5 5.2 7.8 7.5 2.4 2 5.1 3.7 7.8 5.4 7.1 4.4 14.2 8.8 21.3 13.3 1.8 1.1 3.5 2.2 5.3 3.3 13.2 8.2 26.4 16.5 39.7 24.7 4.8 3 10.1 8.9 6.2 13.4-2.2 2.5-8.8 3.4-12 3-15.3-2-26.3.8-40-5.8-13.9-6.6-27.6-22.4-41.5-29-4.1-2-13.6 2.7-17.7.8-11.8-5.6-18.9-19-30.7-24.6-7-3.3-16.7-2.2-23.6-5.6-3.3-1.7-4-7.8-7.3-9.5-5.9-2.9-13.8 1.6-19.7-1.2-4.6-2.2-7.2-11.9-11.8-14.1-4.1-2-9.6-1.4-13.7-3.4-6.3-3-11.7-7.2-18-10.2-7.7-3.7-19.8-4.8-27.5-8.5-7-3.4-24.8-16.9-23.3-27.3 2.5-17.3 23.5.2 26.8-1.9z"
            />
            <path
              fill="#852D31"
              d="M1418.7 631.5c-15.3-2-26.3.8-40-5.7-13.9-6.6-27.6-22.4-41.5-29-4.1-2-13.6 2.7-17.8.8-11.8-5.6-18.9-19-30.7-24.6-7-3.3-16.7-2.2-23.6-5.6-3.3-1.7-4-7.8-7.3-9.5-5.9-2.9-13.8 1.6-19.7-1.2-4.6-2.2-7.2-11.9-11.8-14.1-4.1-2-9.6-1.4-13.7-3.4-6.3-3-11.7-7.2-18-10.2-7.7-3.7-19.8-4.8-27.5-8.5-5.7-2.7-18.4-12.1-22.3-21.1-1.2 1.2-2.1 3.1-2.5 5.8-1.5 10.3 16.3 23.9 23.3 27.3 7.7 3.7 19.8 4.8 27.5 8.5 6.3 3 11.7 7.2 18 10.2 4.1 2 9.6 1.4 13.7 3.4 4.6 2.2 7.2 11.9 11.8 14.1 5.9 2.9 13.8-1.7 19.7 1.2 3.3 1.7 4 7.8 7.3 9.5 6.9 3.4 16.6 2.3 23.6 5.6 11.8 5.6 18.9 19 30.7 24.6 4.1 2 13.6-2.7 17.8-.8 13.9 6.6 27.6 22.4 41.5 29 13.7 6.5 24.7 3.7 40 5.8 3.2.4 9.8-.5 12-3 2.7-3.1 1-6.9-2-10-2.7.9-6.3 1.2-8.5.9z"
            />
            <path
              fill="#8F4F29"
              d="M1452.6 594.2c-.7-10-13.5-19-25.6-18-2.5-9.4-13.7-17.2-25.3-17.6-2.8-.1-5.8.1-8.4-1-2.6-1.1-4.2-3.3-5.8-5.4-12.6-15.9-37.1-25.3-59.1-22.7-5.9-11.8-18.9-21.4-33.8-24.9-3.6-.9-7.2-1.4-10.8-2.4-3.1-.8-6.1-2-9.1-3.2-7.8-3.1-15.6-6.2-23.5-9.3-1.9-.8-3.9-1.5-5.8-2.3-14.6-5.8-29.1-11.5-43.7-17.3-5.3-2.1-13.3-3.3-14.8 1.1-.9 2.5 1.4 5.1 3.6 7.1 10.6 9.6 24.2 16.6 37.6 23.3 13.6 6.9 27.2 13.7 40.9 20.6 4 2 8.1 4.1 12.1 6.1 11.5 5.8 16.2 11.1 27.7 16.9 6.8 3.4 20.5 7.4 27.3 10.7 3.3 1.6 5.3 8.7 8.7 10.3 5.9 2.8 13.1.3 18.9 3.2 4.5 2.3 7.1 10.6 11.6 12.8 17.7 8.9 36.3 15.1 54 24 6.9 3.4 29.4 11.7 37.2 6.6 13.1-8.1-13.7-15.5-13.9-18.6z"
            />
            <path
              fill="#852D31"
              d="M1461 599.8c-.4.3-.9.7-1.4 1-7.8 5.1-30.3-3.2-37.2-6.6-17.7-8.9-36.3-15.1-54-24-4.5-2.3-7.1-10.6-11.6-12.8-5.8-2.9-13-.3-18.9-3.2-3.3-1.6-5.3-8.7-8.7-10.3-6.9-3.3-20.5-7.3-27.3-10.7-11.5-5.8-16.2-11.1-27.7-16.9-4-2-8.1-4.1-12.1-6.1-13.6-6.9-27.2-13.7-40.9-20.6-11.7-5.9-23.6-11.9-33.4-19.8-.5.4-.9.9-1.1 1.6-.9 2.5 1.4 5.1 3.6 7.1 10.6 9.6 24.2 16.6 37.6 23.3 13.6 6.9 27.2 13.7 40.9 20.6 4 2 8.1 4.1 12.1 6.1 11.5 5.8 16.2 11.1 27.7 16.9 6.8 3.4 20.5 7.4 27.3 10.7 3.3 1.6 5.3 8.7 8.7 10.3 5.9 2.8 13.1.3 18.9 3.2 4.5 2.3 7.1 10.6 11.6 12.8 17.7 8.9 36.3 15.1 54 24 6.9 3.4 29.4 11.7 37.2 6.6 7.8-4.9 1.2-9.6-5.3-13.2z"
            />
            <path
              fill="#8F4F29"
              d="M1245 457.4c10.3-4.9 26.1-.4 31.5 8.9 10.6-3.2 24.3.7 30.9 8.9 1.6 2 2.9 4.3 5.4 5.6 2.5 1.3 5.6 1.3 8.4 1.3 22.5.7 44.9 13.3 54 30.6 14.9-2 31.3 2.3 42.8 11.1 2.8 2.1 5.2 4.5 8.1 6.5 2.5 1.8 5.2 3.3 8 4.8 7.2 4 14.5 8 21.7 12l5.4 3c13.5 7.4 26.9 14.9 40.4 22.3 4.9 2.7 10.4 7.8 6.8 11.3-2 1.9-5.8 1.7-9 1.2-15.2-2.5-29.3-8.7-43.2-14.8-14.1-6.2-28.1-12.4-42.2-18.5-4.2-1.8-8.4-3.7-12.5-5.5-11.9-5.2-23.8-10.4-35.7-15.7-7-3.1-14.1-6.2-21.1-9.4-3.4-1.5-6.8-3.1-10.1-4.7-5.9-2.7-11.9-5.4-17.9-8-4.7-2.1-9.3-4.1-14-6.2-18.2-8.1-36.4-16.2-54.6-24.2-7.1-3.1-30.1-12.3-29.2-20.6 1.3-13.8 22.9 1.6 26.1.1zM1522.9 538.6c-4.9-3.8-11.6-6.1-18-5.6-2.5-9.4-13.7-17.2-25.3-17.6-2.8-.1-5.8.1-8.4-1-2.6-1.1-4.2-3.3-5.8-5.4-12.6-15.9-37.1-25.3-59.1-22.7-5.9-11.8-18.9-21.4-33.8-24.9-3.6-.9-7.2-1.4-10.8-2.4-3.1-.8-6.1-2-9.1-3.2-7.8-3.1-15.6-6.2-23.5-9.3l-5.8-2.3c-14.6-5.8-29.1-11.5-43.7-17.3-5.3-2.1-13.3-3.3-14.8 1.1-.9 2.5 1.4 5.1 3.6 7.1 10.6 9.6 24.2 16.6 37.6 23.3l40.9 20.6c4 2 8.1 4.1 12.1 6.1l34.5 17.4c6.8 3.4 13.6 6.9 20.5 10.2 3.3 1.6 6.7 3.2 10 4.8 5.9 2.8 11.7 5.7 17.5 8.6 4.5 2.3 9 4.5 13.6 6.8 17.7 8.9 35.4 17.7 53.1 26.6 2.9 1.5 8.5 4.4 14.5 7v-27.9z"
            />
            <path
              fill="#852D31"
              d="M1522.9 561.2c-5.1-1.9-10.6-5.5-16.1-11.4-18.4 1.1-35.4-17.7-53.1-26.6-4.5-2.3-9-4.5-13.6-6.8-5.8-2.9-11.6-5.8-17.5-8.6-3.3-1.6-6.7-3.2-10-4.8-6.9-3.3-13.7-6.8-20.5-10.2l-34.5-17.4-12.1-6.1c-13.6-6.9-27.2-13.7-40.9-20.6-13.3-6.7-26.8-13.5-37.3-23-.9.5-1.6 1.2-2 2.2-.9 2.5 1.4 5.1 3.6 7.1 10.6 9.6 24.2 16.6 37.6 23.3 13.6 6.9 27.2 13.7 40.9 20.6l12.1 6.1 34.5 17.4c6.8 3.4 13.6 6.9 20.5 10.2 3.3 1.6 6.7 3.2 10 4.8 5.9 2.8 11.7 5.7 17.5 8.6 4.5 2.3 5.6 6.8 13.6 6.8 7.4 11 32.4 27.4 52.1 28.7 2.9 4.5 8.8 7.5 15.2 9.1v-9.4z"
            />
            <path
              fill="#8F4F29"
              d="M1393.3 660c-2.5-5.6-32.3-15.5-36.6-20.5-4.3-5-5.6-8.7-9.3-12.4-3.7-3.7-7.4-11.2-20.5-12.4-13-1.2-33.5-8.7-36.6-11.2-3.1-2.5-19.9-18-36.6-21.1-16.8-3.1-27.3-12.4-33.5-17.4-6.2-5-12.4-11.8-21.1-12.4-8.7-.6-18.6-4.3-24.2-5.6-5.6-1.2-15.5-6.2-21.1-5.6s-24.2-6.2-27.3-6.8c-3.1-.6-7.3-9.1-16-6-4.8 1.7-11.3 3.7-13 10.4-4.1-.4-7.3.8-7.8 6-.9 8.7 23.1 18.2 30.5 21.5 19 8.4 38 16.9 57 25.3 4.9 2.2 9.7 4.3 14.6 6.5 6.2 2.8 12.5 5.6 18.7 8.4 3.5 1.6 7 3.3 10.6 4.9 7.3 3.3 14.6 6.6 22 9.8 12.4 5.4 24.8 10.9 37.2 16.3 4.4 1.9 8.7 3.8 13.1 5.7 14.7 6.4 29.4 12.9 44 19.3 14.5 6.4 29.2 12.8 45.1 15.4 2.6.4 5.5.6 7.7-.2.5-.1 1-.4 1.7-1.1 3.2-3.1 3.8-11.2 1.4-16.8z"
            />
            <path
              fill="#852D31"
              d="M1393.6 669.9c-2.2.8-5-2.4-7.6-2.8-15.9-2.6-30.6-1.9-45.1-8.3-14.7-6.4-30.9-24.4-39.6-18.4-14.8 3.1-16-7.5-17.6-10.7-11.4.1-22.8-1.1-23.1-11.9-21.3 1-34.5-6.9-37.3-14.1-1.4-3.6-3.4-9-7-10.6-4.4 6-20.7.7-19-5.6-4.9-2.2-12.8-6.8-17.7-9-4.7 3.3-25.7-5.9-44.7-14.3-11.7 3.7-38.9-16.2-41.5-24.7-2.1.7-3.6 2.4-4 5.7-.9 8.7 22.1 11.3 26.5 26 3.5 11.8 31.5 3.2 47.3 16.7 6.5 5.6 21.1 11.8 26.4 11.8 6.5 0 13 6.8 19.2 9.6 3.5 1.6 8.4.8 11.9 2.4 7.3 3.3 12.5 11.9 19.8 15.1 12.4 5.4 27 5.6 39.4 11 4.4 1.9-1.4 6.7 13.3 13 14.7 6.4 29.1 5.6 43.8 12.1 14.5 6.4 24.5 15.1 40.3 17.8 2.6.4 10.3-1.7 12.5-2.6.5-.1 1-.4 1.7-1.1 1.8-1.6 2.8-4.4 3.1-7.5-.3.1-.7.3-1 .4z"
            />
            <path
              fill="#68C902"
              d="M1333.6 584.4s6.7-11.9 18.4-10.4c-11.8 6.7-14.2 13.7-14.2 13.7s6.1-6.3 11.1-6.5c-5.9 3.9-12.5 13-12.5 13l.7-4.4-3.5 2.4 4.4-9.2s-3.5.4-4.4 1.4z"
            />
            <ellipse
              cx="1313"
              cy="680.4"
              fill="#D7BF60"
              rx="8.6"
              ry="3.9"
              transform="rotate(-7.252 1312.373 680.312)"
            />
            <path
              fill="#E1BC75"
              d="M1317.6 678.1c.5 4-2.5 4.6-6.8 5.2-4.2.5-8 .8-8.5-3.2s2.4-10 6.6-10.5c4.2-.6 8.2 4.5 8.7 8.5z"
            />
            <path
              fill="#CAA175"
              d="M1312.9 670.7c.6 1.2 1.1 2.4 1.2 3.5.5 4-2.5 4.6-6.8 5.2-1.9.2-3.7.4-5.1.2v.5c.5 4 4.3 3.7 8.5 3.2s7.3-1.2 6.8-5.2c-.2-2.6-2.1-5.8-4.6-7.4z"
            />
            <ellipse
              cx="1419.5"
              cy="660.4"
              fill="#D7BF60"
              rx="8.6"
              ry="3.9"
              transform="rotate(-7.252 1418.836 660.337)"
            />
            <path
              fill="#E1BC75"
              d="M1424.1 658.1c.5 4-2.5 4.6-6.8 5.2-4.2.5-8 .8-8.5-3.2s2.4-10 6.6-10.5c4.2-.6 8.2 4.5 8.7 8.5z"
            />
            <path
              fill="#CAA175"
              d="M1419.4 650.7c.6 1.2 1.1 2.4 1.2 3.5.5 4-2.5 4.6-6.8 5.2-1.9.2-3.7.4-5.1.2v.5c.5 4 4.3 3.7 8.5 3.2s7.3-1.2 6.8-5.2c-.2-2.6-2.1-5.8-4.6-7.4z"
            />
            <ellipse
              cx="1497.3"
              cy="600.3"
              fill="#D7BF60"
              rx="4.7"
              ry="2.1"
              transform="rotate(-7.252 1496.66 600.285)"
            />
            <path
              fill="#E1BC75"
              d="M1499.8 599c.3 2.2-1.4 2.5-3.7 2.8-2.3.3-4.4.4-4.7-1.8-.3-2.2 1.3-5.5 3.6-5.7 2.4-.2 4.6 2.6 4.8 4.7z"
            />
            <path
              fill="#CAA175"
              d="M1497.3 595c.3.6.6 1.3.7 1.9.3 2.2-1.4 2.5-3.7 2.8-1 .1-2 .2-2.8.1v.3c.3 2.2 2.4 2 4.7 1.8 2.3-.3 4-.6 3.7-2.8-.2-1.5-1.3-3.2-2.6-4.1z"
            />
            <ellipse
              cx="1477.3"
              cy="621.8"
              fill="#D7BF60"
              rx="4.7"
              ry="2.1"
              transform="rotate(-7.252 1476.684 621.852)"
            />
            <path
              fill="#E1BC75"
              d="M1479.9 620.6c.3 2.2-1.4 2.5-3.7 2.8-2.3.3-4.4.4-4.7-1.8-.3-2.2 1.3-5.5 3.6-5.7 2.3-.3 4.5 2.5 4.8 4.7z"
            />
            <path
              fill="#CAA175"
              d="M1477.3 616.5c.3.6.6 1.3.7 1.9.3 2.2-1.4 2.5-3.7 2.8-1 .1-2 .2-2.8.1v.3c.3 2.2 2.4 2 4.7 1.8 2.3-.3 4-.6 3.7-2.8-.2-1.4-1.2-3.1-2.6-4.1z"
            />
            <ellipse
              cx="1232.4"
              cy="441.6"
              fill="#D7BF60"
              rx="8"
              ry="3.7"
              transform="rotate(-7.252 1231.91 441.64)"
            />
            <path
              fill="#E1BC75"
              d="M1236.8 439.5c.5 3.7-2.4 4.3-6.3 4.8s-7.5.7-8-3 2.2-9.3 6.2-9.8c3.9-.5 7.6 4.3 8.1 8z"
            />
            <path
              fill="#CAA175"
              d="M1232.4 432.5c.6 1.1 1 2.2 1.1 3.3.5 3.7-2.4 4.3-6.3 4.8-1.8.2-3.4.4-4.8.2v.5c.5 3.7 4 3.5 8 3s6.8-1.1 6.3-4.8c-.2-2.5-2-5.4-4.3-7z"
            />
            <g>
              <ellipse
                cx="1334.8"
                cy="671.9"
                fill="#D7BF60"
                rx="5.3"
                ry="2.4"
                transform="rotate(-7.252 1334.18 671.851)"
              />
              <path
                fill="#E1BC75"
                d="M1337.7 670.5c.3 2.5-1.6 2.9-4.2 3.2s-5 .5-5.3-2 1.5-6.2 4.1-6.5c2.6-.4 5 2.8 5.4 5.3z"
              />
              <path
                fill="#CAA175"
                d="M1334.8 665.9c.4.7.7 1.5.8 2.2.3 2.5-1.6 2.9-4.2 3.2-1.2.1-2.3.3-3.2.1v.3c.3 2.5 2.7 2.3 5.3 2 2.6-.3 4.5-.7 4.2-3.2-.3-1.6-1.4-3.6-2.9-4.6z"
              />
            </g>
            <g>
              <ellipse
                cx="1255.5"
                cy="645.3"
                fill="#D7BF60"
                rx="8.6"
                ry="3.9"
                transform="rotate(-7.252 1254.936 645.26)"
              />
              <path
                fill="#E1BC75"
                d="M1260.1 643.1c.5 4-2.5 4.6-6.8 5.2-4.2.5-8 .8-8.5-3.2s2.4-10 6.6-10.5 8.2 4.5 8.7 8.5z"
              />
              <path
                fill="#CAA175"
                d="M1255.5 635.6c.6 1.2 1.1 2.4 1.2 3.5.5 4-2.5 4.6-6.8 5.2-1.9.2-3.7.4-5.1.2v.5c.5 4 4.3 3.7 8.5 3.2s7.3-1.2 6.8-5.2c-.3-2.6-2.2-5.7-4.6-7.4z"
              />
            </g>
            <g>
              <ellipse
                cx="1282.6"
                cy="662"
                fill="#D7BF60"
                rx="5.3"
                ry="2.4"
                transform="rotate(-7.252 1282.038 661.957)"
              />
              <path
                fill="#E1BC75"
                d="M1285.5 660.6c.3 2.5-1.6 2.9-4.2 3.2-2.6.3-5 .5-5.3-2s1.5-6.2 4.1-6.5 5.1 2.8 5.4 5.3z"
              />
              <path
                fill="#CAA175"
                d="M1282.6 656c.4.7.7 1.5.8 2.2.3 2.5-1.6 2.9-4.2 3.2-1.2.1-2.3.3-3.2.1v.3c.3 2.5 2.7 2.3 5.3 2 2.6-.3 4.5-.7 4.2-3.2-.2-1.6-1.4-3.6-2.9-4.6z"
              />
            </g>
            <path
              fill="#852D31"
              d="M1206.5 581c-2.2-4.8 10 .5 10 1.2s-8 3.3-10-1.2zM1322.7 633.2c1.8-4.2 15.7 5 15.7 5s-19.2 3.3-15.7-5z"
            />
            <g>
              <path
                fill="#68C902"
                d="M1150.3 624.1c-9-3.6-16.8-8.9-24-14.2-3.6-2.6-7.2-5.3-10.7-7.7-3.5-2.5-7.1-4.8-10.8-7.1-14.8-9-30.7-16.2-47-23.2-2.3-1.2-4.7-2.4-7.1-3.6 1.2.4 2.4.9 3.6 1.3-.2-.2-.4-.3-.6-.3 0-.1-.1-.9.3-1.2.4-.3.7-.5.7-.7.2.1.4.4.3.6.2-.3.5-.4.8-.5.3 0 .7-.3.6-.6.3.1.7 1.2-.1 2.1.3-.2.6-.1.7-.1.8-.4 1.4-.7 1.3-1 .5.4.8 1.1.4 1.5.6-.6 1.4-.9 2.1-.9.7 0 1.9-.4 1.8-1.1.6.2 1 1.7.3 3.2.2 0 .5 0 .7.1.5.1 1.4.2 1.5-.4.3.2.2.9-.2 1.6h1.3c1.8-.2 1.9-.4 2.4-1.2.1-.2.5-.1.6.1.1.3.2.6.2.8.4.3.7.9.5 1.2.4-.5 1-.9 1.6-1 .6-.1 1.5-.5 1.3-1.1.7.2 1.4 2.4-.2 4.3.5-.3 1.1-.2 1.4-.2v.1c1.6-.9 2.8-1.4 2.8-2 .9.8 1.5 2.3.8 3.1 1.3-1.1 2.8-1.7 4.3-1.7s4-.6 3.7-2.2c1.1.5 1.9 3.5.3 6.6.5 0 1 .1 1.4.2 1 .3 2.9.5 3.2-.6.5.5.4 1.8-.6 3.2.9 0 1.8.2 2.7.2 3.6-.1 4-.6 5.1-2.1.3-.3 1.1 0 1.2.4.7 2 .2 3.7-1.8 4.9-.9.6-1.9 1-2.9 1.2.3.1.6.3.8.4.6 0 1.2.1 1.8.1 2.2 0 2.5-.3 3.2-1.2.2-.2.7 0 .7.2.4 1.2.1 2.3-1.2 3.1-.1.1-.2.1-.3.2.9.5 1.9 1 2.8 1.6 0-.1.1-.1.2-.2.5-.4 1-.6 1-.8.3.2.4.6.3.8.3-.3.7-.5 1.1-.5.4 0 1-.2.9-.6.4.2.7 1.6-.4 2.7.4-.2.7-.1.9 0v.1c1.1-.4 1.9-.7 1.9-1.1.5.6.8 1.6.2 2 .9-.6 1.9-.9 2.9-.8.9.1 2.6-.1 2.5-1.1.7.4.9 2.4-.3 4.2.3 0 .6.1.9.2.6.3 1.8.5 2.1-.1.3.3.1 1.2-.7 2 .6.1 1.1.2 1.7.3 2.3.2 2.6-.1 3.4-.9.2-.2.7.1.7.3.3 1.3-.2 2.4-1.5 3-.6.3-1.2.5-1.9.5l.5.4c.4.1.7.2 1.1.2 1.4.2 1.6 0 2.1-.6.1-.1.4 0 .5.2.2.8-.1 1.5-1 1.9-.1 0-.2.1-.2.1 6.6 5 12.5 9.7 18.5 13.8 6 4.1 12.3 7.5 19.6 9.7-3.1-.5-5.9-1.2-8.7-2.1zm-82.9-49.9c0-.1 0-.2.1-.3-.3.1-.5.2-.8.2l.4.2c.1-.1.2-.1.3-.1z"
              />
            </g>
            <g>
              <path
                fill="#68C902"
                d="M1315.7 707.8c-6.4-6.3-13.8-11.8-21.6-16.9-7.8-5.1-16-9.8-24.3-14.6-8.2-4.9-16.6-10-24.4-15.9-2-1.4-3.9-3.1-5.8-4.6-2-1.5-3.8-3.2-5.6-4.9-.9-.9-1.8-1.7-2.7-2.5-.9-.9-1.7-1.8-2.6-2.6-1.7-1.7-3.3-3.4-4.9-5.1-1.6-1.6-3.3-3.2-4.9-4.6-.8-.7-1.6-1.4-2.5-2-.8-.6-1.5-1.1-2.6-1.7-3.9-2.4-7.9-4.5-11.9-6.3l-3-1.2c-.5-.2-1-.3-1.5-.5l-1.6-.5-6.9-2-13.7-4.1c-18.3-5.6-36.4-11.4-54.6-16.9-5.4-1.8-10.7-3.5-16.2-5.3 2.7.7 5.3 1.4 8 2.1-.4-.2-.9-.4-1.4-.5-.1-.1-.6-1-.1-1.3.5-.3 1.1-.5 1-.6.5.2 1 .5.9.7.3-.3.7-.4 1.3-.4.5 0 1.3-.1.9-.5.7.2 2.1 1.4 1 2.4.4-.1 1 0 1.3 0 1.3-.4 2.4-.5 2.1-.9 1.1.5 2.1 1.4 1.7 1.8.9-.5 2.3-.7 3.7-.6 1.4.1 3.7 0 2.9-.9 1.2.4 2.9 2.1 2.3 3.7.5 0 1 .1 1.4.2 1.1.2 3 .5 2.9-.1.6.3 1 1 .4 1.7.9.1 1.8.2 2.6.3 3.4.2 3.6-.1 4.1-.9.1-.2 1 0 1.3.3.4.3.7.7.9 1 1 .4 2 1.1 1.7 1.5.5-.5 1.5-.8 2.6-.8s2.7-.3 1.9-1c1.4.4 4.1 3 2.1 4.8.9-.3 2.1-.1 2.7 0v.1c2.7-.7 4.8-1.1 4.3-1.8 2.3 1.1 4.3 2.9 3.3 3.7 1.8-1.1 4.6-1.4 7.5-1.2 2.9.2 7.5 0 6-1.9 2.5.8 5.8 4.2 4.7 7.5 1 .1 2 .2 2.9.4 2.2.5 6.1.9 5.9-.3 1.3.6 2 2.1.9 3.5 1.8.1 3.7.4 5.4.4 3.5.1 5.4.1 6.5-.1 1.1-.2 1.5-.7 2.2-1.4.3-.3 2.1.3 2.7.8 2.7 2.7 2.4 4.6-.6 5.4-1.4.4-3.1.5-4.8.6.6.2 1.2.5 1.8.7h.1c1.2.2 2.4.6 3.5.8 4.2.9 4.5.6 5.4-.2.2-.2 1.2.3 1.5.7 1.4 1.8 1.2 3-.7 3.3-.1 0-.3 0-.4.1 1.9 1.1 3.9 2.3 5.6 3.5.1 0 .1-.1.2-.1.8-.2 1.6 0 1.4-.3.5.4.9 1.1.7 1.3.4-.2 1.1-.1 1.7.2.6.3 1.7.6 1.4-.1.8.6 1.6 2.9-.2 3.4.6.1 1.2.6 1.5.8 1.7.4 3.1.8 3 .3 1 1.3 1.6 3 .8 3.1 1.4 0 3.1.6 4.6 1.6 1.6 1 4.3 2.2 4 .7 1.2 1.1 2.1 4 .6 5.6.6.3 1.1.7 1.6 1.1 1.1 1 3.4 2.1 3.5 1.4.6.7.7 1.8-.4 2.3 1.1.5 2.1 1.2 3.1 1.6 4.2 1.8 4.5 1.4 5.5.7.2-.2 1.2.4 1.4.8 1.2 2 .9 3.2-1.1 3.3-.9.1-2-.1-3-.3.4.3.7.5 1.1.8.7.3 1.4.7 2.1 1 2.7 1 2.9.8 3.5.3.1-.1.8.3.9.5.8 1.2.7 2-.6 2.1h-.4c7.5 5.1 14.8 9.5 21.7 13.7 6.9 4.2 13.4 8.3 19.5 12.5 6.1 4.2 11.7 8.7 16.8 13.5 5.1 4.8 9.4 10.2 13.3 15.9-.9-1-1.7-2.1-2.5-3.1l-1.3-1.6c-.4-.5-.8-1-1.3-1.5l-2.8-2.9-1.4-1.4c-.5-.7-1-1.1-1.5-1.6zm-174.6-102.5v-.4c-.5.1-1 .1-1.5.1l.9.3c.2 0 .4-.1.6 0z"
              />
            </g>
            <g>
              <path
                fill="#68C902"
                d="M1396.4 709.3c-9.2.3-18.2-.5-26.9-1.3l-26.2-2.4-13.1-1.2c-4.4-.4-8.8-.9-13.3-1.5-8.9-1.2-18-3.1-26.8-6.6-2.6-1.2-5-2.6-7.5-4.1 1.3.5 2.5 1.1 3.8 1.6-.2-.2-.4-.4-.6-.4 0-.1 0-.9.3-1.2.4-.3.7-.5.7-.6.2.1.4.4.3.6.2-.3.5-.4.8-.5.3 0 .8-.2.6-.5.3.1.7 1.2-.1 2.1.3-.2.6-.1.7-.1.8-.4 1.4-.7 1.4-1 .5.4.8 1.1.5 1.5.6-.6 1.4-.9 2.1-.9.7-.1 1.9-.5 1.7-1.2.6.2 1.1 1.6.5 3.2h.7c.5.1 1.5 0 1.5-.5.3.2.3.9-.1 1.6.5-.1.9-.1 1.3-.1 1.7-.4 1.9-.7 2.2-1.5.1-.2.5-.1.6 0 .2.3.3.5.3.8.4.2.9.7.7 1.1.3-.6.8-1 1.4-1.2.5-.2 1.4-.8 1-1.4.7.1 1.8 2 .6 4.2.5-.4 1.1-.5 1.3-.5v.1c1.4-1.2 2.4-2 2.2-2.6 1.1.5 2 1.9 1.5 2.8.9-1.4 2.3-2.4 3.6-2.8 1.4-.4 3.5-1.8 2.8-3.2 1.2.2 2.7 2.8 2.2 6.1.5-.2.9-.2 1.4-.3 1.1 0 2.9-.6 2.8-1.6.6.3 1 1.6.5 3.2.9-.3 1.7-.5 2.5-.8 3.3-1.4 3.4-2.1 3.8-3.8.1-.4.9-.5 1.2-.1 1.4 1.5 1.6 3.3.3 5.2-.6.9-1.4 1.6-2.2 2.2.3 0 .6.1.9.1.6-.2 1.2-.3 1.7-.6 2.1-.9 2.1-1.3 2.4-2.4.1-.3.6-.3.8-.1.9 1 1 2.1.2 3.3-.1.1-.1.2-.2.3 1.1.1 2.1.2 3.2.3 0-.1 0-.1.1-.2.3-.6.7-.9.6-1.1.3.1.6.4.6.7.1-.4.4-.7.7-.9.3-.2.8-.6.5-1 .4 0 1.3 1.2.8 2.7.3-.3.6-.4.8-.4v.1c.8-.9 1.4-1.5 1.2-1.8.7.3 1.4 1.1 1.1 1.7.5-1 1.3-1.6 2.2-2 .9-.3 2.2-1.2 1.7-2.2.8.1 1.9 1.7 1.6 3.9.3-.1.6-.2.9-.2.7-.1 1.9-.4 1.8-1.1.4.2.7 1 .4 2.1.5-.2 1.1-.3 1.6-.6 2.1-.9 2.2-1.4 2.5-2.5.1-.3.6-.3.8-.1.9 1 1 2.1.2 3.4-.4.6-.8 1-1.3 1.4l.6.1c.4-.1.7-.2 1.1-.4 1.3-.6 1.4-.8 1.6-1.6 0-.2.4-.2.5-.1.6.6.6 1.3.1 2.1l-.2.2c16.4 1.8 29.2 4 43.5 3.4-2.6.5-5.3.9-8 1.1zm-96.1-11.4v-.3c-.3.1-.5.3-.8.4l.4.1c.1-.1.2-.1.4-.2z"
              />
            </g>
            <g>
              <path
                fill="#68C902"
                d="M1443.9 660.5c-1.1.6-2.3 1.4-3.4 2.3-1.1 1-2.1 2.1-3.1 3.4-2 2.6-3.9 5.8-6.4 9.2-1.2 1.7-2.6 3.4-4.2 4.9a48.1 48.1 0 01-4.8 4.2c-3.3 2.5-6.7 4.6-10.1 6.5-13.2 7.4-26.5 14.4-40 21.1-2.1.8-4.2 1.7-6.3 2.6.9-.6 1.9-1.1 2.8-1.7-.2 0-.4 0-.6.2-.1-.1-.7-.5-.7-1s0-.8-.1-.9c.2-.1.5 0 .6.2-.1-.3-.1-.6.1-.9.1-.2.2-.7-.1-.8.2-.2 1.2.3 1.5 1.5 0-.3.2-.5.3-.6.1-.8.2-1.5 0-1.6.5-.1 1.2.2 1.3.7-.1-.8.1-1.5.4-2.1.4-.5.7-1.6.1-2 .5-.2 1.7.4 2.4 2 .1-.2.3-.3.4-.4.4-.3.9-.9.5-1.3.3 0 .8.4 1 1.2.2-.3.5-.6.7-.9.8-1.4.7-1.7.4-2.5-.1-.2.2-.4.4-.3.3.1.5.2.7.4.4-.1 1 0 1.1.4-.2-.7-.1-1.3.1-1.7.2-.5.4-1.4-.2-1.7.5-.3 2.4.5 3 2.9 0-.6.4-1 .5-1.1v.1c.2-1.7.4-3-.1-3.3 1-.2 2.4.4 2.6 1.4-.2-1.6.1-3.1.8-4.2.7-1.1 1.4-3.3.1-4.1.9-.5 3.5.8 5 3.9.2-.4.5-.7.8-.9.7-.6 1.7-1.9 1-2.7.6-.1 1.6.8 2.1 2.4.4-.7.9-1.3 1.3-1.9 1.5-2.8 1.3-3.4.6-5.1-.2-.4.4-.8.8-.7 1.8.6 2.9 2 3 4.2.1 1.1-.1 2-.3 2.9l.7-.4c.3-.5.6-.9.9-1.3 1-1.8.8-2.1.4-3.2-.1-.3.3-.5.5-.5 1.1.4 1.8 1.3 1.9 2.7v.3c.8-.4 1.6-.9 2.4-1.3 0-.1 0-.1-.1-.2-.1-.6 0-1.1-.2-1.2.3-.1.7 0 .8.3-.1-.4-.1-.8 0-1.1.1-.3.2-.9-.2-1.1.3-.2 1.6.3 2 1.8 0-.4.2-.6.3-.8.1-1.1.2-1.9-.1-2.1.7-.1 1.6.2 1.8.9-.2-1.1 0-2 .4-2.7.4-.7.8-2.2-.1-2.6.6-.3 2.2.4 3.4 2.3.1-.3.3-.5.5-.6.4-.4 1-1.3.5-1.8.4-.1 1.1.4 1.5 1.4.2-.5.5-.9.7-1.4.7-1.9.5-2.3-.1-3.3-.1-.2.2-.6.4-.5 1.2.2 2.1.9 2.4 2.3.2.6.2 1.3.1 1.9l.4-.3c.1-.3.3-.6.4-1 .4-1.3.2-1.5-.2-2.1-.1-.1.1-.4.2-.4.8 0 1.4.5 1.6 1.4 0 .1 0 .2.1.3 1.4-1.2 2.8-2.6 3.9-4 1.2-1.4 2.2-2.7 3.2-4.1 1.9-2.6 3.7-5.1 5.5-7.1 1.8-2 3.7-3.6 5.7-4.6 2-1 4-1.4 5.6-1.1-.6-.3-1.9.1-3.2 1zm-65.3 46.3c-.1-.1-.1-.2-.2-.3-.1.3-.1.5-.2.7l.3-.2c.1 0 .1-.1.1-.2z"
              />
            </g>
            <g>
              <path
                fill="#68C902"
                d="M1511.9 616.8c-9.2 5.6-18.1 11.9-26.7 18.6-8.6 6.7-17 13.8-25.4 21-1.4.9-2.7 1.9-4.1 2.8.6-.6 1.1-1.2 1.7-1.8-.2 0-.3.1-.4.2-.1 0-.7-.4-.9-.8-.2-.4-.3-.8-.4-.8.1-.1.4 0 .5.1-.2-.3-.3-.6-.2-.8 0-.2-.1-.6-.3-.7.1-.2 1 .1 1.6 1.2-.1-.3 0-.4 0-.5-.2-.8-.3-1.3-.6-1.4.4-.1 1 .1 1.3.5-.3-.7-.4-1.4-.3-1.9.1-.5.1-1.5-.6-1.8.3-.2 1.5.2 2.6 1.5 0-.2.1-.3.2-.4.2-.3.4-.9 0-1.2.2-.1.7.3 1.2 1 .1-.3.2-.6.2-.9.2-1.3 0-1.5-.5-2.3-.1-.2 0-.4.2-.3.2.1.5.2.7.3.3-.1.8 0 1.1.3-.4-.6-.5-1.1-.5-1.6 0-.4-.1-1.3-.7-1.5.3-.3 2.1.3 3.3 2.4-.2-.5 0-.9.1-1.1l.1.1c-.4-1.6-.6-2.7-1.1-3 .8-.2 2.1.2 2.6 1.1-.7-1.5-.9-2.8-.6-3.8.2-1 .2-3-1.1-3.7.6-.5 3 .5 5.2 3.2.1-.3.2-.6.4-.9.4-.6.8-1.8 0-2.5.4-.1 1.5.6 2.4 2.1.2-.6.4-1.2.5-1.8.4-2.6.1-3.1-.9-4.6-.2-.4.1-.8.4-.7 1.6.5 2.9 1.7 3.6 3.7.3 1 .5 1.8.6 2.7l.5-.4c.1-.4.3-.8.3-1.2.3-1.6 0-2-.6-2.9-.1-.2.1-.5.3-.4 1 .3 1.8 1.1 2.3 2.4 0 .1.1.2.1.3.5-.4 1-.8 1.6-1.3 0-.1-.1-.1-.1-.2-.2-.6-.3-1-.5-1.1.2-.1.5 0 .7.2-.2-.4-.3-.7-.3-1 0-.3-.1-.8-.4-1 .2-.2 1.3.2 2.1 1.6-.1-.4 0-.6.1-.7-.2-1-.3-1.7-.7-1.9.5-.1 1.3.2 1.6.8-.4-1-.5-1.8-.3-2.5.2-.6.2-2-.6-2.4.4-.3 1.9.4 3.3 2.2.1-.2.1-.4.3-.6.3-.3.6-1.1.1-1.6.3-.1.9.5 1.5 1.4.1-.4.3-.7.4-1.2.3-1.7.1-2-.5-3-.1-.2.1-.5.3-.4 1 .4 1.8 1.2 2.2 2.5.2.6.3 1.2.3 1.7l.3-.2c.1-.3.2-.5.2-.8.2-1 .1-1.3-.3-1.9-.1-.2.1-.3.2-.3.7.2 1.1.8 1.4 1.6 0 .1 0 .2.1.2 8.5-5.8 15.6-9.5 23.3-12.9-1.8 1.1-3.1 2.1-4.4 3zm-48.6 34.4l-.2-.2c0 .2.1.5.1.7l.2-.2c-.1-.2-.1-.3-.1-.3z"
              />
            </g>
            <g>
              <ellipse
                cx="1093.9"
                cy="525.6"
                fill="#D7BF60"
                rx="8"
                ry="3.7"
                transform="rotate(-7.252 1093.449 525.587)"
              />
              <path
                fill="#E1BC75"
                d="M1098.3 523.5c.5 3.7-2.4 4.3-6.3 4.8-4 .5-7.5.7-8-3s2.2-9.3 6.2-9.8c3.9-.5 7.6 4.3 8.1 8z"
              />
              <path
                fill="#CAA175"
                d="M1093.9 516.5c.6 1.1 1 2.2 1.1 3.3.5 3.7-2.4 4.3-6.3 4.8-1.8.2-3.4.4-4.8.2v.5c.5 3.7 4 3.5 8 3s6.8-1.1 6.3-4.8c-.2-2.5-2-5.4-4.3-7z"
              />
            </g>
            <g>
              <ellipse
                cx="1103.5"
                cy="576.8"
                fill="#D7BF60"
                rx="6.2"
                ry="2.8"
                transform="rotate(-7.252 1103 576.767)"
              />
              <path
                fill="#E1BC75"
                d="M1106.8 575.2c.4 2.9-1.8 3.3-4.9 3.7-3 .4-5.8.5-6.2-2.3-.4-2.9 1.7-7.2 4.8-7.6 3.1-.4 6 3.3 6.3 6.2z"
              />
              <path
                fill="#CAA175"
                d="M1103.5 569.8c.5.8.8 1.7.9 2.6.4 2.9-1.8 3.3-4.9 3.7-1.4.2-2.6.3-3.7.1v.4c.4 2.9 3.1 2.7 6.2 2.3 3-.4 5.3-.9 4.9-3.7-.3-1.9-1.7-4.2-3.4-5.4z"
              />
            </g>
          </g>
          <g className="text" transform="translate(1230 710) scale(0.85)">
            <path
              fill="#ffffff"
              d="M20.1,14.4c-0.3-2.3-0.8-4.5-1.3-6.6c-0.1-0.5-0.3-1.1-0.4-1.6c0,0,0,0,0,0c-0.5-1.6-1-3.2-1.5-4.7
              c-0.1-0.4-0.3-0.7-0.5-0.8c-0.2-0.2-0.5-0.3-0.9-0.3c-0.1,0-0.2,0-0.3,0h-0.3c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.7,0.1
              c-0.7,0.1-1.1,0.4-1.3,1c-0.5,1.2-0.9,2.4-1.2,3.6c-0.3,1.2-0.6,2.4-0.9,3.6C9.8,7.2,9.4,6,9.1,4.8C8.7,3.6,8.3,2.5,7.8,1.3
              C7.6,1,7.5,0.7,7.3,0.5C7.1,0.4,6.8,0.3,6.5,0.3c-0.1,0-0.2,0-0.3,0H5.9c-0.2,0-0.4,0-0.7,0c-0.2,0-0.5,0-0.7,0.1
              C4.1,0.4,3.9,0.5,3.7,0.6C3.5,0.8,3.4,1,3.3,1.3C2.6,3.6,1.9,5.7,1.4,7.8c-0.5,2.1-1,4.2-1.3,6.4c0,0.1,0,0.2,0,0.2
              c0,0.1,0,0.2,0,0.2c0,0.5,0.3,0.8,0.8,0.9c0.3,0.1,0.6,0.1,0.9,0.1c0.3,0,0.7,0,1.1,0c0.5,0,0.8-0.1,0.9-0.3C3.9,15.3,4,15,4,14.7
              c0.2-1.6,0.4-3.1,0.6-4.5c0.2-1.4,0.5-2.7,0.8-4C5.8,7.6,6.2,9,6.5,10.4c0.3,1.3,0.7,2.5,1.2,3.8c0,0.1,0.1,0.2,0.1,0.3
              c0.1,0.4,0.3,0.6,0.6,0.8c0.2,0.2,0.6,0.3,1,0.3c0.5,0,1-0.1,1.6-0.2c0.3-0.1,0.6-0.2,0.7-0.4c0.2-0.2,0.3-0.4,0.4-0.7
              c0.5-1.3,0.9-2.7,1.2-4c0,0,0,0,0,0c0.3-1.3,0.6-2.7,0.9-4c0.2,1,0.5,1.9,0.7,2.8c0.1,0.5,0.2,1.1,0.3,1.6c0.3,1.5,0.6,2.9,0.8,4.4
              c0.1,0.4,0.2,0.6,0.5,0.7c0.2,0.1,0.5,0.1,0.9,0.1s0.7,0,1.1-0.1c0.4,0,0.7-0.1,1-0.2c0.4-0.1,0.6-0.4,0.6-0.9
              C20.1,14.6,20.1,14.5,20.1,14.4z"
            />
            <path
              fill="#ffffff"
              d="M25.4,1.1c-0.1-0.3-0.2-0.5-0.4-0.7c-0.1-0.1-0.2-0.2-0.3-0.2h0c-0.1-0.1-0.2-0.1-0.4-0.1
              C24.1,0,23.7,0,23.3,0c-0.8,0-1.3,0.2-1.6,0.5c-0.3,0.3-0.5,0.8-0.5,1.5c0,0.4,0,0.8,0.1,1c0,0.1,0.1,0.2,0.1,0.3
              c0.1,0.1,0.1,0.2,0.2,0.3C21.8,3.9,22.1,4,22.3,4c0.3,0.1,0.6,0.1,1,0.1c0.4,0,0.8,0,1.1-0.1c0.3-0.1,0.5-0.2,0.7-0.4
              c0.2-0.2,0.3-0.4,0.3-0.6c0.1-0.2,0.1-0.5,0.1-0.8C25.6,1.8,25.5,1.4,25.4,1.1z M25.1,5.3c-0.1-0.1-0.2-0.2-0.4-0.2
              c-0.1,0-0.2,0-0.3,0H24c-0.3,0-0.6,0-0.9,0c-0.3,0-0.6,0.1-0.8,0.1c-0.3,0-0.5,0.2-0.5,0.4c-0.1,0.2-0.1,0.5-0.1,0.8
              c-0.1,0.8-0.1,1.7-0.1,2.5c0,0.8,0,1.6,0,2.4c0,0.5,0,1,0,1.5c0,0.5,0,1,0.1,1.5c0,0.4,0.1,0.6,0.2,0.8c0.1,0.2,0.4,0.3,0.9,0.3
              c0.4,0,0.8,0.1,1.2,0.1c0.3,0,0.5,0,0.6-0.1c0.2,0,0.3-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.4c0-0.2,0-0.3,0-0.6
              c0.1-1.4,0.2-2.8,0.2-4.2c0-1.3,0.1-2.8,0.1-4.3C25.2,5.6,25.1,5.4,25.1,5.3z"
            />
            <path
              fill="#ffffff"
              d="M32.2,8.5c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0.1,0.9,0.1,1.3,0.1c0.3,0,0.5-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.3-0.5
              C35,8,35,7.6,35.1,7.2c0.1-0.4,0.1-0.7,0.1-1c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.2-0.3-0.3-0.5-0.3C34,5.1,33.6,4.9,33,4.9
              c-0.5-0.1-1.1-0.1-1.6-0.1c-0.6,0-1.2,0.1-1.8,0.2c-0.6,0.2-1.1,0.4-1.5,0.7C27.6,6,27.3,6.3,27,6.7c-0.3,0.4-0.4,0.9-0.4,1.4
              c0,0.5,0.1,1,0.3,1.4c0.2,0.4,0.5,0.7,0.8,1c0.3,0.3,0.7,0.5,1.1,0.7c0.4,0.2,0.7,0.3,1.1,0.5c0.3,0.1,0.6,0.3,0.8,0.4
              c0.2,0.1,0.3,0.3,0.3,0.4c0,0.2-0.1,0.3-0.3,0.4c-0.2,0.1-0.5,0.1-0.8,0.1c-0.2,0-0.5,0-0.8-0.1c-0.3-0.1-0.6-0.2-0.8-0.3
              c-0.3-0.1-0.5-0.2-0.6-0.2c-0.2,0-0.3,0.1-0.4,0.5c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.2,0.5-0.2,0.7c0,0.2-0.1,0.3-0.1,0.5
              c0,0.3,0.2,0.6,0.6,0.7c0.4,0.2,0.9,0.3,1.4,0.4c0.5,0.1,1,0.1,1.6,0.1c0.7,0,1.3-0.1,1.9-0.2c0.6-0.2,1.1-0.4,1.5-0.6
              c0.4-0.3,0.8-0.6,1-1c0.2-0.4,0.4-0.8,0.4-1.3c0-0.6-0.1-1-0.4-1.4c-0.2-0.4-0.5-0.7-0.9-1C33.4,10,33,9.8,32.6,9.6
              c-0.4-0.2-0.8-0.3-1.2-0.5C31,9,30.7,8.8,30.4,8.7c-0.2-0.1-0.4-0.3-0.4-0.4c0-0.2,0.1-0.4,0.4-0.5c0.2-0.1,0.6-0.1,0.9-0.1
              c0.2,0,0.4,0,0.7,0.1v0.2C32.1,8.2,32.1,8.4,32.2,8.5z"
            />
            <path
              fill="#ffffff"
              d="M46.3,13.6c0-0.1-0.1-0.2-0.1-0.4c-0.1-0.2-0.2-0.4-0.2-0.5c-0.1-0.2-0.2-0.3-0.3-0.5
              c-0.2-0.3-0.3-0.4-0.5-0.4c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.4,0.2c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.2-0.6,0.2
              c-0.2,0.1-0.4,0.1-0.7,0.2c-0.2,0-0.4,0.1-0.6,0.1c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.4-0.5-0.5-0.8
              c-0.1-0.3-0.2-0.6-0.2-1c0-0.4,0.1-0.7,0.2-1C40,9,40.2,8.7,40.5,8.5C40.7,8.3,41,8.1,41.4,8c0.3-0.1,0.7-0.2,1.1-0.3
              c0,0.2,0,0.4,0,0.7c0,0.2,0,0.4,0.1,0.6c0.1,0.6,0.4,0.9,1,1c0.3,0.1,0.7,0.1,1.2,0.1c0.3,0,0.5-0.1,0.6-0.2
              c0.1-0.1,0.2-0.3,0.2-0.6c0.1-0.5,0.1-1,0.1-1.5c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4-0.1-0.7c0-0.4-0.1-0.7-0.3-0.9
              c-0.1-0.2-0.4-0.3-0.7-0.5c-0.4-0.1-0.7-0.2-1.1-0.3c-0.4,0-0.7-0.1-1-0.1c-0.8,0-1.7,0.1-2.4,0.4c-0.8,0.3-1.5,0.7-2.1,1.2
              c-0.6,0.5-1.1,1.1-1.5,1.8c-0.4,0.7-0.6,1.4-0.6,2.2c0,0.3,0,0.6,0.1,0.9c0.1,0.4,0.2,0.7,0.3,1.1s0.4,0.8,0.6,1.2
              c0.3,0.4,0.6,0.8,1.1,1c0.4,0.3,1,0.6,1.7,0.8c0.7,0.2,1.4,0.3,2.3,0.3c0.4,0,0.8,0,1.1-0.1c0.4-0.1,0.8-0.1,1.1-0.3
              c0.4-0.1,0.7-0.2,1-0.4c0.3-0.2,0.6-0.3,0.8-0.5c0.2-0.2,0.3-0.4,0.3-0.6C46.3,13.8,46.3,13.7,46.3,13.6z"
            />
            <path
              fill="#ffffff"
              d="M57.8,8.3c-0.2-0.6-0.5-1.1-0.9-1.6c-0.4-0.5-1-1-1.6-1.3c-0.7-0.4-1.5-0.5-2.5-0.5c-0.7,0-1.4,0.1-2.1,0.4
              c-0.7,0.3-1.3,0.7-1.8,1.1c-0.5,0.5-0.9,1.1-1.2,1.8c-0.3,0.7-0.5,1.4-0.5,2.2c0,0.8,0.2,1.6,0.5,2.2c0.3,0.7,0.7,1.2,1.2,1.7
              c0.5,0.5,1.1,0.8,1.7,1.1c0.7,0.3,1.3,0.4,2,0.4c1,0,1.9-0.1,2.6-0.4s1.4-0.6,1.8-1c0.2-0.2,0.3-0.5,0.3-0.7v-0.2
              c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.3-0.1-0.5c0-0.2-0.1-0.3-0.1-0.5C57,12.2,57,12.1,56.9,12c-0.1-0.1-0.1-0.1-0.3-0.1
              c-0.1,0-0.2,0-0.5,0.1c-0.4,0.2-0.9,0.4-1.4,0.5c-0.5,0.1-0.9,0.2-1.3,0.2c-0.5,0-1-0.1-1.4-0.3c-0.5-0.2-0.8-0.5-1.1-0.8
              c0.6,0,1.2-0.1,1.8-0.1c0.6-0.1,1.2-0.1,1.8-0.2c0.6-0.1,1.1-0.2,1.6-0.3c0.5-0.1,0.9-0.2,1.3-0.4c0.2-0.1,0.4-0.2,0.4-0.3
              c0.1-0.1,0.1-0.3,0.1-0.5C58.1,9.3,58,8.9,57.8,8.3z M52.6,9.3c-0.7,0.1-1.4,0.1-2,0.1C50.7,9,51,8.6,51.5,8.3
              c0.4-0.3,0.9-0.4,1.4-0.4c0.3,0,0.7,0.1,1,0.3c0.3,0.2,0.6,0.5,0.7,0.9C54,9.1,53.3,9.2,52.6,9.3z"
            />
            <path
              fill="#ffffff"
              d="M63,2L63,2c0-0.4,0-0.7,0-1c0-0.3,0-0.6-0.1-0.7c-0.1-0.1-0.2-0.2-0.5-0.2c-0.3,0-0.7,0-1.1,0.1
              c-0.4,0-0.8,0.1-1.1,0.2c-0.2,0.1-0.4,0.2-0.5,0.3c-0.1,0.1-0.1,0.3-0.2,0.7c0,0.1,0,0.2,0,0.3c-0.1,1.2-0.2,2.4-0.2,3.7
              c0,1.3-0.1,2.5-0.1,3.8c0,1.1,0,2.1,0,3.1c0,0.9,0.1,1.7,0.1,2.4c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.4,0.3,0.9,0.3c0.1,0,0.2,0,0.3,0
              h0.6c0.1,0,0.2,0,0.3,0c0.5,0,0.7-0.2,0.8-0.4c0.1-0.2,0.2-0.5,0.2-0.9c0.1-0.6,0.1-1.4,0.2-2.3s0.1-1.8,0.1-2.8c0-1,0-2,0.1-3.1
              s0-2.1,0-3.1C63,2.7,63,2.4,63,2z"
            />
            <path
              fill="#ffffff"
              d="M68.6,2c0-0.3,0-0.7,0-1c0-0.3,0-0.6-0.2-0.7c-0.1-0.1-0.3-0.2-0.5-0.2c-0.3,0-0.7,0-1.1,0.1
              c-0.4,0-0.8,0.1-1.1,0.2c-0.2,0.1-0.4,0.2-0.4,0.3c-0.1,0.2-0.2,0.5-0.2,1c0,0.2,0,0.3,0,0.5c-0.1,1-0.2,2-0.2,3.1
              c0,1.3-0.1,2.5-0.1,3.8c0,1.1,0,2.1,0,3.1c0,0.9,0.1,1.7,0.1,2.4c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.4,0.3,0.9,0.3c0.1,0,0.2,0,0.3,0
              H67c0.1,0,0.2,0,0.3,0c0.5,0,0.7-0.2,0.8-0.4c0.1-0.2,0.1-0.5,0.2-0.9c0.1-0.6,0.1-1.4,0.1-2.3c0.1-0.9,0.1-1.8,0.1-2.8
              c0-1,0.1-2,0.1-3.1c0-1.1,0-2.1,0-3.1V2.7C68.6,2.5,68.6,2.2,68.6,2z"
            />
            <path
              fill="#ffffff"
              d="M81.7,5.7c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.3-0.2s-0.3-0.1-0.5-0.2c-0.3-0.1-0.7-0.2-1.1-0.2
              c-0.4,0-0.7-0.1-1-0.1c-0.2,0-0.3,0-0.4,0.1C78.1,4.8,78,5,78,5.3c-0.6-0.3-1.2-0.4-1.9-0.4c-0.8,0-1.5,0.2-2.2,0.5
              c-0.7,0.3-1.4,0.8-2,1.4c-0.6,0.6-1,1.3-1.4,2.1c-0.4,0.8-0.5,1.6-0.5,2.6c0,0.6,0.1,1.2,0.3,1.8c0.2,0.5,0.5,1,0.9,1.4
              c0.4,0.4,0.9,0.7,1.4,0.9c0.5,0.2,1.2,0.3,1.8,0.3c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,1.1-0.5,1.5-0.9c0,0.3,0.1,0.5,0.1,0.7
              c0.1,0.2,0.3,0.3,0.7,0.3c0.1,0,0.2,0,0.3,0h0.8c0.2,0,0.3,0,0.4,0c0.4,0,0.6-0.2,0.8-0.3c0.2-0.2,0.2-0.5,0.3-0.9
              c0.2-1.3,0.3-2.7,0.3-4.1c0.1-1.4,0.1-2.8,0.1-4.1C81.7,6,81.7,5.8,81.7,5.7z M77.9,10c0,0.6-0.1,1.1-0.1,1.7
              c-0.3,0.3-0.7,0.6-1,0.7c-0.4,0.2-0.7,0.2-1.1,0.2c-0.6,0-1.1-0.2-1.4-0.5c-0.3-0.3-0.5-0.8-0.5-1.3c0-0.3,0.1-0.6,0.2-0.9
              c0.1-0.3,0.3-0.6,0.5-0.9c0.2-0.3,0.5-0.5,0.8-0.7C75.8,8,76.2,8,76.6,8c0.3,0,0.5,0,0.8,0.1c0.2,0,0.5,0.1,0.7,0.2
              C78,8.8,78,9.4,77.9,10z"
            />
            <path
              fill="#ffffff"
              d="M93.8,6.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2-0.2-0.4-0.4-0.6-0.6c-0.3-0.2-0.7-0.3-1.1-0.4
              c-0.4-0.1-0.7-0.1-1-0.1c-0.6,0-1.2,0.1-1.8,0.3c-0.2,0.1-0.3,0.1-0.5,0.2c-0.4,0.2-0.8,0.4-1.2,0.7c0-0.1,0-0.2,0-0.3
              c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1-0.1-0.2c-0.1-0.1-0.2-0.2-0.4-0.2c-0.2,0-0.4,0-0.6,0c-0.2,0-0.5,0-0.7,0.1
              c-0.1,0-0.1,0-0.1,0h0c-0.2,0-0.4,0-0.5,0.1C84.5,5,84.3,5,84.2,5c-0.3,0.1-0.5,0.2-0.5,0.4c-0.1,0.2-0.1,0.5-0.1,0.8
              c0,0.3,0,0.5,0,0.8v0.8c0,1.1,0,2.2,0.1,3.4c0.1,1.1,0.2,2.2,0.3,3.3c0.1,0.3,0.1,0.6,0.3,0.8c0.1,0.2,0.4,0.3,0.9,0.3
              c0.1,0,0.2,0,0.3,0h0.7c0.1,0,0.2,0,0.3,0c0.5,0,0.8-0.1,0.9-0.2c0.2-0.1,0.2-0.3,0.2-0.6c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.2
              c-0.1-0.9-0.2-1.8-0.2-2.7c-0.1-0.9-0.1-1.8-0.1-2.8c0.4-0.3,0.8-0.5,1.2-0.6c0.4-0.1,0.8-0.2,1.1-0.2c0.3,0,0.5,0.1,0.6,0.3
              c0.1,0.2,0.2,0.5,0.2,0.8c0,0.9,0,1.6,0,2.2c0,0.6,0,1.1-0.1,1.5c0,0.4-0.1,0.7-0.1,1c0,0.2,0,0.4,0,0.6c0,0.5,0.2,0.8,0.7,0.9
              c0.3,0.1,0.7,0.1,1,0.2c0.3,0,0.6,0.1,0.8,0.1c0.4,0,0.6-0.1,0.7-0.3c0.1-0.2,0.2-0.4,0.2-0.7c0.1-0.6,0.2-1.3,0.2-1.9
              c0.1-0.6,0.1-1.3,0.2-1.9c0-0.6,0.1-1.1,0.1-1.7c0-0.5,0-1,0-1.3C94.2,7.2,94.1,6.6,93.8,6.2z"
            />
            <path
              fill="#ffffff"
              d="M106.1,8.4c-0.2-0.6-0.5-1.1-0.9-1.6c-0.4-0.5-1-1-1.6-1.3c-0.7-0.4-1.5-0.5-2.5-0.5c-0.7,0-1.4,0.1-2.1,0.4
              c-0.7,0.3-1.3,0.7-1.8,1.1c-0.5,0.5-0.9,1.1-1.2,1.8c-0.3,0.7-0.5,1.4-0.5,2.2c0,0.8,0.2,1.6,0.5,2.2c0.3,0.7,0.7,1.2,1.2,1.7
              c0.5,0.5,1.1,0.8,1.7,1.1c0.7,0.3,1.3,0.4,2,0.4c1,0,1.9-0.1,2.6-0.4s1.4-0.6,1.8-1c0.2-0.2,0.3-0.5,0.3-0.7v-0.2
              c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.3-0.1-0.5c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.1-0.1-0.3-0.1
              c-0.1,0-0.2,0-0.5,0.1c-0.4,0.2-0.9,0.4-1.4,0.5c-0.5,0.1-0.9,0.2-1.3,0.2c-0.5,0-1-0.1-1.4-0.3c-0.5-0.2-0.8-0.5-1.1-0.8
              c0.6,0,1.2-0.1,1.8-0.1c0.6-0.1,1.2-0.1,1.8-0.2c0.6-0.1,1.1-0.2,1.6-0.3c0.5-0.1,0.9-0.2,1.3-0.4c0.2-0.1,0.4-0.2,0.4-0.3
              c0.1-0.1,0.1-0.3,0.1-0.5C106.4,9.4,106.3,8.9,106.1,8.4z M100.9,9.3c-0.7,0.1-1.4,0.1-2,0.1C99,9,99.3,8.6,99.8,8.3
              c0.4-0.3,0.9-0.4,1.4-0.4c0.3,0,0.7,0.1,1,0.3c0.3,0.2,0.6,0.5,0.7,0.9C102.3,9.2,101.6,9.3,100.9,9.3z"
            />
            <path
              fill="#ffffff"
              d="M118.1,7.8c-0.1-0.2-0.3-0.3-0.4-0.5c-0.6-0.6-1.3-1-2.2-1.2c0-0.2,0-0.3,0.1-0.3c0-0.1,0-0.1,0-0.2
              c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.4-0.2c-0.3-0.1-0.5-0.1-0.8-0.2c-0.3,0-0.6-0.1-0.8-0.1c-0.7,0-1.5,0.1-2.2,0.4
              c-0.7,0.3-1.3,0.7-1.9,1.1c0,0,0,0,0,0c-0.6,0.5-1,1.1-1.4,1.8c-0.4,0.7-0.5,1.5-0.5,2.4c0,0.9,0.2,1.6,0.4,2.3
              c0.3,0.7,0.7,1.2,1.2,1.7c0.5,0.4,1.2,0.8,1.9,1c0.8,0.2,1.6,0.3,2.5,0.3c0.7,0,1.4-0.1,2-0.3c0.7-0.2,1.3-0.5,1.8-1
              c0.5-0.4,1-1,1.3-1.6c0.3-0.6,0.5-1.4,0.5-2.2C119,9.7,118.7,8.7,118.1,7.8z M115.4,11.6c-0.1,0.3-0.3,0.5-0.6,0.6
              c-0.2,0.2-0.5,0.3-0.8,0.4c-0.3,0.1-0.6,0.1-0.9,0.1c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.5-0.2-0.7-0.4c-0.2-0.2-0.4-0.4-0.5-0.6
              c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.8,0.2-1.4,0.7-1.9c0.5-0.5,1.1-0.8,1.8-0.9c0,0.2,0,0.4,0,0.5c0,0.1,0.1,0.2,0.2,0.3
              c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0.1,0.4,0.2c0.4,0.1,0.7,0.3,1,0.6c0.2,0.3,0.4,0.6,0.4,1C115.6,11.1,115.5,11.3,115.4,11.6z"
            />
            <path
              fill="#ffffff"
              d="M130.6,9.2c0-0.1,0-0.2,0-0.3c-0.1-1-0.2-2-0.2-3c-0.1-0.4-0.2-0.6-0.4-0.7C129.8,5,129.5,5,129.1,5
              c-0.2,0-0.4,0-0.7,0c-0.2,0-0.4,0.1-0.6,0.1c-0.4,0.1-0.7,0.2-0.9,0.4c-0.2,0.2-0.2,0.4-0.2,0.7c0,0.1,0,0.4,0.1,0.7
              c0,0.3,0.1,0.8,0.1,1.3c0,0.1,0,0.2,0,0.3c0,0.4,0.1,0.9,0.1,1.4c0,0.6,0.1,1.2,0.1,1.9c-0.4,0.3-0.8,0.5-1.2,0.6
              c-0.4,0.1-0.8,0.2-1.2,0.2c-0.3,0-0.5-0.1-0.6-0.3c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.6,0-1.1,0.1-1.7c0-0.6,0.1-1.1,0.1-1.6
              c0,0,0,0,0,0c0-0.5,0.1-0.9,0.1-1.2c0-0.4,0.1-0.6,0.1-0.8c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.1-0.3-0.2-0.5-0.3
              C123.2,5.1,123,5,122.8,5c-0.2,0-0.5,0-0.7,0c-0.5,0-0.8,0.1-1,0.2s-0.4,0.4-0.4,0.8c-0.1,0.6-0.2,1.1-0.2,1.7c0,0.1,0,0.1,0,0.2
              c-0.1,0.6-0.1,1.3-0.2,1.9c0,0.6-0.1,1.1-0.1,1.7c0,0.5,0,1,0,1.4c0,0.7,0.1,1.2,0.3,1.6c0.2,0.4,0.5,0.7,0.9,0.9
              c0.3,0.2,0.7,0.3,1.1,0.4c0.4,0.1,0.7,0.1,1,0.1c0.6,0,1.2-0.1,1.8-0.3c0.6-0.2,1.2-0.5,1.7-0.8c0,0.1,0,0.2,0,0.3
              c0,0.1,0,0.2,0,0.3c0,0.4,0.3,0.7,0.8,0.7c0.3,0,0.7,0,1.2-0.1c0.4-0.1,0.9-0.2,1.2-0.3c0.3-0.1,0.4-0.3,0.5-0.5
              c0.1-0.2,0.1-0.5,0.1-0.8c0-0.2,0-0.5,0-0.8v-0.8C130.7,11.5,130.7,10.3,130.6,9.2z"
            />
            <path
              fill="#ffffff"
              d="M137.5,8.5c0.1,0.1,0.3,0.2,0.6,0.2c0.4,0.1,0.9,0.1,1.3,0.1c0.3,0,0.5-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.3-0.5
              c0.1-0.3,0.1-0.6,0.2-1c0.1-0.4,0.1-0.7,0.1-1c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.2-0.3-0.3-0.5-0.3c-0.4-0.1-0.9-0.3-1.5-0.4
              c-0.5-0.1-1.1-0.1-1.6-0.1c-0.6,0-1.2,0.1-1.8,0.2c-0.6,0.2-1.1,0.4-1.5,0.7c-0.5,0.3-0.8,0.7-1.1,1.1s-0.4,0.9-0.4,1.4
              c0,0.4,0,0.7,0.1,0.9c0.1,0.2,0.1,0.3,0.2,0.4c0.2,0.4,0.5,0.7,0.8,1c0.3,0.3,0.7,0.5,1.1,0.7c0.4,0.2,0.7,0.3,1.1,0.5
              c0.3,0.1,0.6,0.3,0.8,0.4c0.2,0.1,0.3,0.3,0.3,0.4c0,0.2-0.1,0.3-0.3,0.4c-0.2,0.1-0.5,0.1-0.8,0.1c-0.2,0-0.5,0-0.8-0.1
              c-0.3-0.1-0.6-0.2-0.8-0.3c-0.3-0.1-0.5-0.2-0.6-0.2c-0.2,0-0.3,0.1-0.5,0.5c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.2,0.5-0.2,0.7
              c0,0.2-0.1,0.3-0.1,0.5c0,0.3,0.2,0.6,0.6,0.7c0.4,0.2,0.9,0.3,1.4,0.4c0.5,0.1,1,0.1,1.6,0.1c0.7,0,1.3-0.1,1.9-0.2
              c0.1,0,0.2-0.1,0.3-0.1c0.4-0.1,0.8-0.3,1.2-0.5c0.4-0.3,0.8-0.6,1-1c0.2-0.4,0.4-0.8,0.4-1.3c0-0.2,0-0.5-0.1-0.6
              c-0.1-0.3-0.2-0.5-0.3-0.8c-0.2-0.4-0.6-0.7-0.9-1c-0.2-0.1-0.4-0.3-0.7-0.4c0,0,0,0,0,0c-0.2-0.1-0.3-0.2-0.5-0.3
              c-0.4-0.2-0.8-0.3-1.2-0.5c-0.4-0.1-0.7-0.3-0.9-0.4c-0.2-0.1-0.4-0.3-0.4-0.4c0-0.2,0.1-0.4,0.4-0.5c0.2-0.1,0.6-0.1,0.9-0.1
              c0.2,0,0.4,0,0.7,0.1v0.2C137.4,8.2,137.4,8.4,137.5,8.5z"
            />
          </g>
          {resources && (
            <>
              <ResourceLink
                r={resources[0]}
                svgComponent={resource1SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[0], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[1]}
                svgComponent={resource2SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[1], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[2]}
                svgComponent={resource3SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[2], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[3]}
                svgComponent={resource4SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[3], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[4]}
                svgComponent={resource5SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[4], e.target as SVGElement)
                }
                onElementLeave={(e) =>
                  onElementHover(resources[4], e.target as SVGElement)
                }
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[5]}
                svgComponent={resource6SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[5], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
            </>
          )}
        </g>
      </g>
    </g>
  );
};
export default MiscellaneousLink;
